import React from 'react';
import classNames from 'classnames';

type WorkStatusCountProps = {
  status: string;
  count: number;
  className: string;
};

function WorkStatusCount({ status, count, className }: WorkStatusCountProps) {
  return (
    <div
      className={classNames(
        'd-flex flex-direction-column align-items-center justify-content-center median-office-time__work-status-count',
        className
      )}
    >
      <p className="font-size-18 font-weight-bold">{count}</p>
      <p className="work-status-count__title font-size-12">{status}</p>
    </div>
  );
}

export default WorkStatusCount;
